// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import './assets/reset.css'
import axios from 'axios'
import Vant from 'vant'
import 'vant/lib/index.css'
import './assets/iconfont/iconfont.css'
Vue.use(Vant);
import { Lazyload } from 'vant';
Vue.use(Lazyload);

import NutUI from '@nutui/nutui';
import '@nutui/nutui/dist/nutui.css';

import moment from "vue-moment";

import './assets/iconfont/iconfont.css'
import router from './router'


import VueImageSwipe from 'vue-image-swipe'
import 'vue-image-swipe/dist/vue-image-swipe.css'
import config from '@/utils/config.js';
Vue.use(VueImageSwipe);

import wcSwiper from 'wc-swiper'
import 'wc-swiper/style.css'
Vue.use(wcSwiper);

NutUI.install(Vue);
Vue.use(moment); //实例
import { Dialog } from 'vant';
Vue.use(Dialog);
import * as filters from './filters/textTransform' // global filters

Object.keys(filters).forEach(key => {
  // console.log(filters[key],'555555')
  Vue.filter(key, filters[key])
})

Vue.prototype.$http = axios
Vue.config.productionTip = false
// 修改baseURL配置逻辑，确保测试环境也能正确处理计算器请求
if (config.salaryCalculator.includes('/merchant/calc')) {
  axios.defaults.baseURL = ''
} else {
  axios.defaults.baseURL = '/bpo-web'
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js